var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mb-1", attrs: { cols: "12", sm: "2" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Per page" } },
                [
                  _c("b-form-select", {
                    attrs: {
                      id: "perPageSelect",
                      options: _vm.pageOptions.map(function (option) {
                        return { text: option, value: option }
                      }),
                      size: "sm",
                    },
                    model: {
                      value: _vm.perPage,
                      callback: function ($$v) {
                        _vm.perPage = $$v
                      },
                      expression: "perPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "mb-1", attrs: { cols: "12", sm: "3" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Filter" } },
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "filterInput",
                          type: "search",
                          placeholder: "Type to Search",
                        },
                        model: {
                          value: _vm.searchQuery,
                          callback: function ($$v) {
                            _vm.searchQuery = $$v
                          },
                          expression: "searchQuery",
                        },
                      }),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { disabled: !_vm.searchQuery },
                              on: {
                                click: function ($event) {
                                  _vm.searchQuery = ""
                                },
                              },
                            },
                            [_vm._v(" Clear ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Campaign Name",
                            "label-for": "campaignNameSelect",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                id: "campaignNameSelect",
                                options: _vm.campaigns,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.filterTable()
                                },
                              },
                              model: {
                                value: _vm.selectedCampaignName,
                                callback: function ($$v) {
                                  _vm.selectedCampaignName = $$v
                                },
                                expression: "selectedCampaignName",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "All" } }, [
                                _vm._v("All"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Status",
                            "label-for": "statusSelect",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: {
                                id: "statusSelect",
                                options: _vm.statuses,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.filterTable()
                                },
                              },
                              model: {
                                value: _vm.selectedStatus,
                                callback: function ($$v) {
                                  _vm.selectedStatus = $$v
                                },
                                expression: "selectedStatus",
                              },
                            },
                            [
                              _c("option", { attrs: { value: "All" } }, [
                                _vm._v("All"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex align-items-center",
                      attrs: { cols: "12", sm: "4" },
                    },
                    [
                      _c("b-button", { on: { click: _vm.clearFilters } }, [
                        _vm._v(" Clear "),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end my-1",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            to: {
                              path: "/email/add",
                            },
                          },
                        },
                        [_vm._v(" Add Email Campaign ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              !_vm.loading
                ? _c("b-table", {
                    attrs: {
                      striped: "",
                      hover: "",
                      responsive: "",
                      items: _vm.tableItems,
                      fields: _vm.fields,
                      "per-page": _vm.perPage,
                      "current-page": _vm.currentPage,
                      "sort-by": _vm.sortBy,
                      "sort-desc": _vm.sortDesc,
                    },
                    on: {
                      "update:sortBy": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sort-by": function ($event) {
                        _vm.sortBy = $event
                      },
                      "update:sortDesc": function ($event) {
                        _vm.sortDesc = $event
                      },
                      "update:sort-desc": function ($event) {
                        _vm.sortDesc = $event
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(id)",
                          fn: function (data) {
                            return [_vm._v(" " + _vm._s(data.item.id) + " ")]
                          },
                        },
                        {
                          key: "cell(status)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-badge",
                                {
                                  attrs: {
                                    variant: _vm.getStatusVariant(
                                      data.item.status
                                    ),
                                  },
                                },
                                [_vm._v(_vm._s(data.item.status))]
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(createdOn)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formatDate(data.item.createdOn)) +
                                  " "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(actions)",
                          fn: function (data) {
                            return [
                              _c(
                                "b-dropdown",
                                {
                                  attrs: {
                                    variant: "link",
                                    "toggle-class": "text-decoration-none",
                                    "no-caret": "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _c("feather-icon", {
                                              staticClass:
                                                "text-body align-middle mr-25",
                                              attrs: {
                                                icon: "MoreVerticalIcon",
                                                size: "16",
                                              },
                                            }),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  [
                                    "DRAFT",
                                    "SCHEDULED",
                                    "CANCELLED",
                                    "SENT",
                                    "COMPLETED",
                                  ].includes(data.item.status)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to: {
                                              name: "email-view-campaign",
                                              params: { id: data.item.id },
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "EyeIcon" },
                                          }),
                                          _c("span", [_vm._v("View")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  ["DRAFT"].includes(data.item.status)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          attrs: {
                                            to: {
                                              name: "email-edit-campaign",
                                              params: { id: data.item.id },
                                            },
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.prepareEditLead(
                                                data.item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "EditIcon" },
                                          }),
                                          _c("span", [_vm._v("Edit")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  ["DRAFT"].includes(data.item.status)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteCampaign(
                                                data.item.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "TrashIcon" },
                                          }),
                                          _c("span", [_vm._v("Delete")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  ["DRAFT"].includes(data.item.status)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.sendFeedback(
                                                data.item.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "UserIcon" },
                                          }),
                                          _c("span", [_vm._v("Send")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  ["SCHEDULED"].includes(data.item.status)
                                    ? _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelCampaign(
                                                data.item.id
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("feather-icon", {
                                            staticClass: "mr-50",
                                            attrs: { icon: "XIcon" },
                                          }),
                                          _c("span", [_vm._v("Cancel")]),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1777379894
                    ),
                  })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              !_vm.loading
                ? _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "my-0",
                        attrs: {
                          "total-rows": _vm.rows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }